import React from "react";
import TabSlider from "../../common/TabSlider";
import { SlotTabData } from "../../helper/Helper";
import { SlotsIcon } from "../../helper/Icon2";
import SwiperSlider from "../../common/SwiperSlider";

function SlotTabContent() {
  return (
    <>
      <SwiperSlider
        sectionHeading={"Slots"}
        icon={<SlotsIcon />}
        data={SlotTabData}
      />
    </>
  );
}

export default SlotTabContent;
